import React from 'react';
import { ContractRefreshProvider } from '../../../../../contexts/ContractRefreshContext';
import ContractStatesHistory from './ContractStatesHistory';

const ContractStatesHistoryWrapper: React.FC = () => {
    return (
        <ContractRefreshProvider>
            <ContractStatesHistory />
        </ContractRefreshProvider>
    );
};

export default ContractStatesHistoryWrapper;